import { createContext, useContext, useEffect, useState } from "react";
import { useWebGalleryStore } from ".";
import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LNG_CODES } from "../constants";
import { getBrowserLanguageCode } from "../utils";

interface LanguageContextInterface {
  toggleLngPref: any;
  lng: string;
}

const LanguageContext = createContext<LanguageContextInterface>({
  toggleLngPref: null,
  lng: DEFAULT_LANGUAGE_CODE,
});

const getInitialLanguage = (isMultiLanguageEnabled: boolean): string => {
  const localStorageLang = localStorage.getItem("currentLanguage");
  const browserDefaultLang = window.navigator
    .language as keyof SUPPORTED_LNG_CODES;

  if (isMultiLanguageEnabled) {
    return (
      localStorageLang ??
      getBrowserLanguageCode(browserDefaultLang) ??
      DEFAULT_LANGUAGE_CODE
    );
  } else {
    return DEFAULT_LANGUAGE_CODE;
  }
};

export const LanguageContextProvider: React.FunctionComponent<{}> = ({
  children,
}) => {
  const store = useWebGalleryStore();
  const [lng, setLng] = useState(() =>
    getInitialLanguage(
      store.features?.UIEnhancements === "Active" &&
        store.features?.MultiLanguage === "Active"
    )
  );

  const toggleLngPref = (lng: string) => {
    setLng(lng);
  };

  useEffect(() => {
    localStorage.setItem("currentLanguage", lng);
  }, [lng]);

  return (
    <LanguageContext.Provider value={{ lng, toggleLngPref }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const LanguageContextConsumer = LanguageContext.Consumer;

export const useLanguageContext = () => useContext(LanguageContext);
